import { CommonError } from "../../types";
import { FETCH_GROUP_TICKERS_FAILURE, FETCH_GROUP_TICKERS_REQUEST, FETCH_GROUP_TICKERS_SUCCESS, FETCH_TICKERS_FAILURE, FETCH_TICKERS_REQUEST, FETCH_TICKERS_SUCCESS, SET_CURRENT_TICKERS } from "./constants";
import { CurrentTicker, TickerInfo } from "./types";

export interface FetchTickersGroupRequestAction {
  type: typeof FETCH_GROUP_TICKERS_REQUEST;
  payload: string;
}

export interface FetchTickersGroupSuccessAction {
  type: typeof FETCH_GROUP_TICKERS_SUCCESS;
  payload: string[];
}

export interface FetchTickersGroupFailureAction {
  type: typeof FETCH_GROUP_TICKERS_FAILURE;
  payload: CommonError;
}


export interface FetchTickersRequestAction {
  type: typeof FETCH_TICKERS_REQUEST;
}

export interface FetchTickersSuccessAction {
  type: typeof FETCH_TICKERS_SUCCESS;
  payload: TickerInfo;
}

export interface FetchTickersFailureAction {
  type: typeof FETCH_TICKERS_FAILURE;
  payload: CommonError;
}

export interface SetCurrentTickerAction {
  type: typeof SET_CURRENT_TICKERS,
  payload: CurrentTicker
}
export type TickerActions = FetchTickersGroupRequestAction | FetchTickersGroupSuccessAction | FetchTickersGroupFailureAction | FetchTickersRequestAction | FetchTickersSuccessAction | FetchTickersFailureAction | SetCurrentTickerAction;

export const fetchTickersGroupRequest = (group: string): FetchTickersGroupRequestAction => ({
  type: FETCH_GROUP_TICKERS_REQUEST,
  payload: group,
});

export const fetchTickersGroupSuccess = (tickers: string[]): FetchTickersGroupSuccessAction => ({
  type: FETCH_GROUP_TICKERS_SUCCESS,
  payload: tickers,
});

export const fetchTickersGroupFailure = (error: CommonError): FetchTickersGroupFailureAction => ({
  type: FETCH_GROUP_TICKERS_FAILURE,
  payload: error,
});


export const fetchTickersRequest = (): FetchTickersRequestAction => ({
  type: FETCH_TICKERS_REQUEST,
});

export const fetchTickersSuccess = (tickers: TickerInfo): FetchTickersSuccessAction => ({
  type: FETCH_TICKERS_SUCCESS,
  payload: tickers,
});

export const fetchTickersFailure = (error: CommonError): FetchTickersFailureAction => ({
  type: FETCH_TICKERS_FAILURE,
  payload: error,
});

export const setCurrentTicker =
  (payload: CurrentTicker) => ({
    type: SET_CURRENT_TICKERS,
    payload,
  });
